import { useFlags } from 'flagsmith/react';

export const useLoginAppDownloadBannerFlag = () => {
  const flags = useFlags(['msr_login_app_dl_banners']);
  return flags.msr_login_app_dl_banners.enabled;
};
